import { EnumWithDescription } from "../../../enums/enums";

export function enumToMap<T>(EnumClass: EnumWithDescription<T>) {
    return EnumClass.enumWithDescriptions;
}
